export const messages = {
  en: {
    message: {
      Geo_контроль: "Geo",
      Geo_enabled: "Enabled",
      Geo_тип_списка: "Type list:",
      Geo_коды: "Codes",
      Geo_не_удалось_получить_список_кодов_стран:
        "Error occured when receiving the data: Geo Codes",
      EPG_Каналы: "EPG Channels",
      Login: "Login",
      IPs_контроль: "IPs control",
      Абоненты: "Accounts",
      Адаптер: "Adapter",
      Администрирование: "Administration",
      Адрес: "Address",
      Активен: "Active",
      Активирован: "Activated",
      Включен: "Enabled",
      Возраст: "Age",
      Выводить_на_сайте: "Display on site",
      Выгружать_в_ios: "IOS accessable",
      Выгружать_в_android: "Android accessable",
      Выход: "Exit",
      Главная: "Main",
      Да: "Yes",
      "Действительно_удалить_запись?":
        "Are you sure you want to delete the item?",
      "Действительно_удалить_источник?":
        "Are you sure you want to delete the source?",
      "Действительно_удалить_канал?":
        "Are you sure you want to delete  the channel?",
      "Действительно_удалить_категорию?":
        "Are you sure you want to delete the category?",
      "Действительно_удалить_пакет?":
        "Are you sure you want to delete the subscription",
      "Действительно_удалить_пользователя?":
        "Are you sure you want to delete the user?",
      "Действительно_удалить_поток?":
        "Are you sure you want to delete the stream?",
      "Действительно_удалить_роль?":
        "Are you sure you want to delete the role?",
      "Действительно_удалить_сервис?":
        "Are you sure you want to delete the service?",
      Добавить: "Add new",
      Добавить_EPG: "Add EPG",
      Добавить_канал: "Add Channel",
      Добавить_категорию: "Add category",
      Добавить_пакет: "Add package",
      Добавить_пользователя: "Add user",
      Добавить_поток: "Add stream",
      Добавить_роль: "Add role",
      Добавить_сервис: "Add service",
      Добро_пожаловать_в_панель_управления: "Welcome to the management panel",
      Закрыть: "Close",
      Записи_не_найдены: "No records found",
      Запись_успешно_сохранена: "Saved successfully",
      Запись_успешно_удалена: "Deleted successfully",
      Импортировать_лого: "Import logo from source",
      Источник: "Provider",
      Источник_для_отображения_каналов: "Channel source",
      "Источники_импорта_-_Редактирование": "Import sources - Edit",
      Источники_импорта: "EPG sources",
      Импорт_програмы: "Import",
      Импорт_програмы_успешно: "Import has done",
      Сервис_импорта_недоступен: "Import service is unavailable",
      Нет_права_на_импорт: "No permission to import",
      Импорт_EPG_сервис: "EPG import (service)",
      Импорт_EPG_сервис_идёт: "Running:",
      Импорт_EPG_сервис_с_времени: "since",
      Импорт_EPG_сервис_последний_запуск: "Last run",
      Импорт_EPG_сервис_вид_проверка: "check of",
      Импорт_EPG_сервис_вид_импорт: "import of",
      Импорт_EPG_сервис_вид_каталог: "channel catalogue update",
      Импорт_EPG_сервис_вид_проверка_каталога: "channel catalogue check",
      Импорт_EPG_сервис_каталог_кнопка: "Update catalogue (service)",
      Импорт_EPG_сервис_каталог_завершён: "Catalogue update finished",
      Импорт_EPG_сервис_каталог_проверка_завершена: "Catalogue check finished",
      Импорт_EPG_сервис_было_бы: "would be",
      Импорт_EPG_сервис_новых: "new",
      Импорт_EPG_сервис_выключено: "disabled",
      Импорт_EPG_сервис_вернулось: "re-enabled",
      Импорт_EPG_сервис_итого: "Total",
      Импорт_EPG_сервис_источников_мн: "sources",
      Импорт_EPG_сервис_вид_очистка: "old programmes cleanup",
      Импорт_EPG_сервис_всех_каналов: "all channels",
      Импорт_EPG_сервис_канала: "channel",
      Импорт_EPG_сервис_каналов_род: "channels",
      Импорт_EPG_сервис_запущен: "Started",
      Импорт_EPG_сервис_уже_идёт: "Already running",
      Импорт_EPG_сервис_проверка_завершена: "Check without writing finished",
      Импорт_EPG_сервис_завершён: "Import finished",
      Импорт_EPG_сервис_за: "in",
      Импорт_EPG_сервис_мин: "min",
      Импорт_EPG_сервис_с: "s",
      Импорт_EPG_сервис_каналов: "Channels",
      Импорт_EPG_сервис_вставлено: "inserted",
      Импорт_EPG_сервис_вставлено_бы: "to insert",
      Импорт_EPG_сервис_удалено: "deleted",
      Импорт_EPG_сервис_удалено_бы: "to delete",
      Импорт_EPG_сервис_хвост: "tail kept",
      Импорт_EPG_сервис_в_прошлом: "in the past",
      Импорт_EPG_сервис_не_ok: "Not ok",
      Импорт_EPG_сервис_и_ещё: "and more:",
      Импорт_EPG_сервис_успешно: "success",
      Импорт_EPG_сервис_с_ошибками: "with errors",
      Импорт_EPG_сервис_каналов_мн: "channels",
      Импорт_EPG_сервис_прерван: "cancelled",
      Импорт_EPG_сервис_остановить: "Stop",
      Импорт_EPG_сервис_статус: "Import (status)",
      Импорт_EPG_сервис_остановка_принята: "Stop accepted: the run finishes the current channel",
      Итог_EPG: {
        заголовок: "Run summary",
        загрузка: "Loading…",
        недоступен: "Run summary unavailable: the service was restarted or the run was evicted by newer runs",
        запуск: "Run",
        вид: "Kind",
        источник_запуска: "Started by",
        начало: "Started",
        окончание: "Finished",
        статус: "Status",
        ошибка: "Reason",
        каналов: "Channels",
        по_статусам: "By status",
        источники: "Sources",
        источник: "Source",
        сообщение: "Message",
        каналы_не_ok: "Channels with status other than ok",
        канал: "Channel",
        все_ok: "All channels are ok",
        легенда: "Legend",
        origin_schedule: "schedule",
        origin_button: "panel button",
        origin_cli: "server command",
        run_succeeded: "success — no channel (source) errors",
        run_partial: "with errors — some channels (sources) failed; the rest are written",
        run_failed: "failed — the run did not execute (e.g. database unavailable)",
        run_cancelled: "cancelled — stopped by the Stop button, service shutdown or crash; written channels stay",
        st_ok: "programmes received, future schedule replaced",
        st_no_future_programmes: "the source sent only programmes starting before the import time; future programmes unchanged, past gaps filled",
        st_no_programmes: "no programmes for the channel in the source response; database unchanged",
        st_source_unavailable: "the source could not be downloaded or is corrupted; database unchanged",
        st_binding_changed: "the channel binding changed during the run; skipped until the next run",
        st_not_bound: "the channel is not bound to a live EPG channel",
        st_unsupported_handler: "source handler is not supported by the service (disabled sources)",
        st_locked_by_other_writer: "channel programmes locked by another writer; the next run fixes it",
        st_commit_unknown: "commit error — old or new programmes; the next run fixes it",
        st_error: "write or parse error; channel unchanged",
        n_inserted: "inserted — new programmes written",
        n_deleted: "deleted — old future programmes replaced",
        n_tail_kept: "tail kept — old future programmes after the end of new data, nothing to replace them with",
        n_kept_before_from: "kept before new data — old programmes between the import time and the start of new data",
        n_past_deleted: "past deleted — old past programmes (last 26 days) replaced by the source version, including identical ones",
        n_past_inserted: "past inserted — past programmes from the source (last 26 days)",
        n_past_skipped: "past skipped — older than 26 days or overlapping a programme the import does not touch",
        n_dropped_after_shift: "dropped after boundary — new programmes after an old programme running past the end of new data",
        cat_ok: "source catalogue received and compared",
        cat_empty_catalog: "empty catalogue from the source; database unchanged",
        cat_source_unavailable: "source could not be downloaded; database unchanged",
        cat_source_changed: "source settings changed during the run; catalogue not applied",
        cat_unsupported_handler: "handler not supported (disabled sources), skipped",
        cat_new: "new — source channels added to the catalogue",
        cat_disabled: "disabled — channels gone from the source (alive = 0); bindings kept",
        cat_reenabled: "re-enabled — previously disabled channels back in the source",
        cat_unchanged: "unchanged — channels present in both"
      },
      Импорт_EPG_сервис_ошибка: "failed",
      Импорт_EPG_сервис_не_отвечает: "Import service is not responding",
      Импорт_EPG_сервис_продолжается: "Import is still running",
      Импорт_EPG_сервис_проверить_снова: "Check again",
      Импорт_EPG_сервис_состояние_недоступно: "State is unavailable, check the channel programme",
      Качество: "Quality",
      К_списку_абонентов: "List of accounts",
      К_списку_пакетов: "List of packages",
      К_списку_каналов: "List of channels",
      К_списку_сервисов: "List of services",
      К_списку_категорий: "List of categories",
      К_списку_колокейшинов: "List of colocations",
      К_списку_фильмов: "List of movies",
      "Каналы_-_Редактирование": "Channels - Edit",
      Каналы_источников: "Channels for sources",
      Каналы: "Channels",
      "Категории_-_Редактирование": "Categories - Edit",
      Категории: "Categories",
      "Категории_-_Extended": "Extended",
      Колокейшн: "Colocation",
      Колокейшены: "Colocations",
      "Колокейшены_-_Редактирование": "Colocations - Edit",
      Колокейшн_запасной: "Colocation spare",
      Колокейшин_запасной_включен: "Colocation spare enabled",
      Комментарий: "Comment",
      Контакты: "Contacts",
      Коррекция_времени_EPG: "EPG offset (sec.)",
      "Лайв-стриминг": "Live streaming",
      Логотип: "Logo image",
      Макс_адресов: "Max. addresses",
      Макс_потоков: "Max. streams",
      Минимальный_возраст: "Min.age",
      Название: "Name",
      Неверное_значение: "Wrong value",
      Нет: "No",
      Новый_пароль: "New password",
      Обработчик: "Handler",
      Общие: "Common",
      Описание: "Description",
      Опции: "Options",
      Отмена: "Cancel",
      Ошибка_получения_данных: "Error occured when receiving the data",
      Ошибка_сохранения: "Could not save",
      Ошибка_удаления_записи: "Could not delete",
      "Пакеты_-_Редактирование": "Package - Edit",
      Пакеты: "Packages",
      Пароли_не_совпадают: "Password does not match",
      Пароль_не_может_быть_пустым: "Could not use empty passwords",
      Пароль_успешно_изменен: "Password successfully changed",
      Пароль: "Password",
      Партнёр: "Partner",
      потоки_клонирование_завершилось: "Streams cloning completed",
      потоки_ошибка_клонирования: "Stream cloning is not completed",
      потоки_клонирование: "Клонирование",
      "потоки_действительно_клонировать?": "Действительно клонировать?",
      Потоки: "Потоки",
      Посмотреть_потоки: "Streams",
      "Поток_-_Редактирование": "Stream - Edit",
      Тип_аккаунта: "Type",
      Тип_аккаунта_дата_обновления: "Type updated at",
      Повторите_пароль: "Reenter password",
      "Пользователи_-_Редактирование": "Users - Edit",
      Пользователи: "Users",
      Порядок_сохранён: "Order saved",
      Применять_точные_метки: "Apply EPG correction labels",
      "Программа_передач_-_Просмотр": "EPG - View",
      "Продолжительность_хранения_записи_(дней)": "Record lifetime (days)",
      Редактирование_абонента: "Account edit",
      Родительский_код: "Parent code",
      "Роли_-_Редактирование": "Roles - Edit",
      Роли: "Roles",
      "Сервисы_-_Редактирование": "Services - Edit",
      "Сервисы_ключей_-_Редактирование": "Key services - Edit",
      Сервисы_ключей: "Key services",
      Сервисы: "Services",
      Сменить_пароль: "Change password",
      Смещение_прямого_эфира: "Live broadcast offset",
      Гео_контроль: "Geo control",
      Смотреть_программу: "Show",
      Создать: "New",
      Сохранить: "Save",
      "Список_каналов_-_Просмотр": "Channels - View",
      Управление_Источниками_импорта: "EPG sources management",
      Статистика: "Statistics",
      Статистика_Dashboard: "Dashboard",
      Статистика_Дневной_отчет: "Reports",
      Статистика_Megogo: "Megogo",
      Статистика_Создание_Отчета: "Create report",
      Статистика_Отчет_Готов: "Report ready",
      Статистика_Лог_запросов: "Log requests",
      Статистика_Лог_сессий: "Log sessions",
      Токен: "Shortcode",
      Timeshift_Enabled: "Timeshift",
      Apks: "Apks",
      Apk_Добавить: "Add Apk",
      Apk_Редактирование: "Apk Edit",
      Apk_enabled: "Enabled",
      Apk_description: "Description",
      Apk_version: "Version",
      Apk_build: "Build",
      Apk_payload: "Apk file",
      Apk_name: "File name",
      Apk_ips_list: "IPs list only",
      Apk_ips_only: "IPs only",
      Apk_ips_exclude: "IPs exclude",
      Apk_ips_re_only: "IPs last digitals only",
      Apk_ips_re_exclude: "IPs last digitals exclude",
      Apk_brand: "Brand",
      Видеотека: "Movies",
      Видеотека_Каталог: "Movies",
      "Видеотека_-_Редактирование": "Movie - Edit",
      "Видеотека_-_Описание": "Description",
      "Видеотека_-_Жанры": "VOD Genres",
      "Видеотека_-_id": "ID",
      "Видеотека_-_Продолжительность": "Mins",
      "Видеотека_-_Контроль": "Control",
      "Видеотека_-_Режисеры": "Directors",
      "Видеотека_-_Актеры": "Actors",
      "Видеотека_-_Год": "Year",
      "Видеотека_-_Пакеты": "VOD Packages",
      "Видеотека_-_Пакеты_Редактирование": "VOD Package - Edit",
      "Видеотека_-_Пакеты_Список_фильмов": "VOD Package - Movies",
      "Видеотека_-_Сервисы": "VOD Services",
      Страны: "Countries",
      Нет_прав_доступа_на_чтение: "No permissions to read",
      Нет_прав_доступа_на_обновление: "No permissions to update"
    }
  },
  ru: {
    message: {
      Geo_контроль: "Geo Контроль",
      Geo_enabled: "Включен",
      Geo_тип_списка: "Тип списка:",
      Geo_коды: "Коды",
      Geo_не_удалось_получить_список_кодов_стран:
        "Не удалось получить коды стран",
      EPG_Каналы: "EPG Каналы",
      Login: "Авторизация",
      IPs_контроль: "IPs контроль",
      Абоненты: "Абоненты",
      Адаптер: "Адаптер",
      Администрирование: "Администрирование",
      Адрес: "Адрес",
      Активен: "Активен",
      Активирован: "Активирован",
      Включен: "Включен",
      Возраст: "Возраст",
      Выводить_на_сайте: "Выводить на сайте",
      Выгружать_в_ios: "Выгружать в IOS",
      Выгружать_в_android: "Выгружать в Android",
      Выход: "Выход",
      Главная: "Главная",
      Да: "Да",
      "Действительно_удалить_запись?": "Действительно удалить запись?",
      "Действительно_удалить_источник?": "Действительно удалить источник?",
      "Действительно_удалить_канал?": "Действительно удалить канал?",
      "Действительно_удалить_категорию?": "Действительно удалить категорию?",
      "Действительно_удалить_пакет?": "Действительно удалить пакет?",
      "Действительно_удалить_пользователя?":
        "Действительно удалить пользователя?",
      "Действительно_удалить_поток?": "Действительно удалить поток?",
      "Действительно_удалить_роль?": "Действительно удалить роль?",
      "Действительно_удалить_сервис?": "Действительно удалить сервис?",
      Добавить: "Добавить",
      Добавить_EPG: "Добавить EPG",
      Добавить_канал: "Добавить канал",
      Добавить_категорию: "Добавить категорию",
      Добавить_пакет: "Добавить пакет",
      Добавить_пользователя: "Добавить пользователя",
      Добавить_поток: "Добавить поток",
      Добавить_роль: "Добавить роль",
      Добавить_сервис: "Добавить сервис",
      Добро_пожаловать_в_панель_управления:
        "Добро пожаловать в панель управления",
      Закрыть: "Закрыть",
      Записи_не_найдены: "Записи не найдены",
      Запись_успешно_сохранена: "Запись успешно сохранена",
      Запись_успешно_удалена: "Запись успешно удалена",
      Импортировать_лого: "Импортировать лого с источника",
      Источник_для_отображения_каналов: "Источник для отображения каналов",
      "Источники_импорта_-_Редактирование":
        "Источники импорта - Редактирование",
      Источники_импорта: "Источники импорта",
      Импорт_програмы: "Импорт",
      Импорт_програмы_успешно: "Импорт програмы завершился",
      Сервис_импорта_недоступен: "Сервис импорта недоступен",
      Нет_права_на_импорт: "Нет права на импорт",
      Импорт_EPG_сервис: "Импорт EPG (сервис)",
      Импорт_EPG_сервис_идёт: "Идёт",
      Импорт_EPG_сервис_с_времени: "с",
      Импорт_EPG_сервис_последний_запуск: "Последний запуск",
      Импорт_EPG_сервис_вид_проверка: "проверка",
      Импорт_EPG_сервис_вид_импорт: "импорт",
      Импорт_EPG_сервис_вид_каталог: "обновление каталога каналов",
      Импорт_EPG_сервис_вид_проверка_каталога: "проверка каталога каналов",
      Импорт_EPG_сервис_каталог_кнопка: "Обновить каталог (сервис)",
      Импорт_EPG_сервис_каталог_завершён: "Обновление каталога завершено",
      Импорт_EPG_сервис_каталог_проверка_завершена: "Проверка каталога завершена",
      Импорт_EPG_сервис_было_бы: "было бы",
      Импорт_EPG_сервис_новых: "новых",
      Импорт_EPG_сервис_выключено: "выключено",
      Импорт_EPG_сервис_вернулось: "вернулось",
      Импорт_EPG_сервис_итого: "Итого",
      Импорт_EPG_сервис_источников_мн: "источников",
      Импорт_EPG_сервис_вид_очистка: "очистка старых передач",
      Импорт_EPG_сервис_всех_каналов: "всех каналов",
      Импорт_EPG_сервис_канала: "канала",
      Импорт_EPG_сервис_каналов_род: "каналов",
      Импорт_EPG_сервис_запущен: "Запущен",
      Импорт_EPG_сервис_уже_идёт: "Уже идёт",
      Импорт_EPG_сервис_проверка_завершена: "Проверка без записи завершена",
      Импорт_EPG_сервис_завершён: "Импорт завершён",
      Импорт_EPG_сервис_за: "за",
      Импорт_EPG_сервис_мин: "мин",
      Импорт_EPG_сервис_с: "с",
      Импорт_EPG_сервис_каналов: "Каналов",
      Импорт_EPG_сервис_вставлено: "вставлено",
      Импорт_EPG_сервис_вставлено_бы: "вставлено бы",
      Импорт_EPG_сервис_удалено: "удалено",
      Импорт_EPG_сервис_удалено_бы: "удалено бы",
      Импорт_EPG_сервис_хвост: "хвост сохранён",
      Импорт_EPG_сервис_в_прошлом: "в прошлом",
      Импорт_EPG_сервис_не_ok: "Не ok",
      Импорт_EPG_сервис_и_ещё: "и ещё",
      Импорт_EPG_сервис_успешно: "успешно",
      Импорт_EPG_сервис_с_ошибками: "с ошибками",
      Импорт_EPG_сервис_каналов_мн: "каналов",
      Импорт_EPG_сервис_прерван: "прервана",
      Импорт_EPG_сервис_остановить: "Остановить",
      Импорт_EPG_сервис_статус: "Импорт (статус)",
      Импорт_EPG_сервис_остановка_принята: "Остановка принята: запуск завершает текущий канал",
      Итог_EPG: {
        заголовок: "Итог запуска",
        загрузка: "Загрузка…",
        недоступен: "Итог запуска недоступен: сервис перезапущен или запуск вытеснен более новыми",
        запуск: "Запуск",
        вид: "Вид",
        источник_запуска: "Кто запустил",
        начало: "Начало",
        окончание: "Окончание",
        статус: "Статус",
        ошибка: "Причина",
        каналов: "Каналов",
        по_статусам: "По статусам",
        источники: "Источники",
        источник: "Источник",
        сообщение: "Сообщение",
        каналы_не_ok: "Каналы со статусом не ok",
        канал: "Канал",
        все_ok: "У всех каналов статус ok",
        легенда: "Что означают поля",
        origin_schedule: "расписание",
        origin_button: "кнопка в панели",
        origin_cli: "команда на сервере",
        run_succeeded: "успешно — у всех каналов (источников) статус без ошибки",
        run_partial: "с ошибками — у части каналов (источников) ошибка; остальные записаны",
        run_failed: "ошибка — запуск не выполнен (например, база недоступна)",
        run_cancelled: "прервана — остановлен кнопкой «Остановить», остановкой сервиса или сбоем; записанные каналы остаются",
        st_ok: "передачи получены, будущее расписание канала заменено присланным",
        st_no_future_programmes: "источник прислал передачи канала, но все они начинаются раньше момента импорта; будущие передачи в базе не меняются, пропуски прошлого заполняются",
        st_no_programmes: "в ответе источника нет передач канала (канала нет в каталоге источника); передачи в базе не меняются",
        st_source_unavailable: "источник не скачался или ответ повреждён; передачи в базе не меняются",
        st_binding_changed: "привязку канала изменили во время импорта; канал пропущен, исправит следующий запуск",
        st_not_bound: "канал не привязан к живому каналу EPG",
        st_unsupported_handler: "обработчик источника не поддерживается сервисом (отключённые источники)",
        st_locked_by_other_writer: "передачи канала заняты другим писателем; исправит следующий запуск",
        st_commit_unknown: "ошибка при фиксации записи — у канала либо новые, либо прежние передачи; исправит следующий запуск",
        st_error: "ошибка записи или разбора; канал не изменён",
        n_inserted: "вставлено — новые передачи, записанные в базу",
        n_deleted: "удалено — прежние будущие передачи, заменённые присланными",
        n_tail_kept: "хвост сохранён — прежние будущие передачи после конца присланных данных: заменить их нечем, они остаются",
        n_kept_before_from: "сохранено до начала новых — прежние передачи между моментом импорта и началом присланных данных",
        n_past_deleted: "удалено в прошлом — прежние передачи прошлого (за 26 дней), заменённые версией источника, в том числе совпадающие",
        n_past_inserted: "вставлено в прошлом — передачи прошлого из источника (за 26 дней)",
        n_past_skipped: "прошлое пропущено — старше 26 дней или пересекает передачу, которую импорт не трогает",
        n_dropped_after_shift: "отброшено за границей — присланные передачи после идущей прежней передачи, которая заходит за конец присланных данных",
        cat_ok: "каталог источника получен и сверен",
        cat_empty_catalog: "источник прислал пустой каталог; каталог в базе не меняется",
        cat_source_unavailable: "источник не скачался; каталог в базе не меняется",
        cat_source_changed: "настройки источника изменили во время обновления; каталог не применён",
        cat_unsupported_handler: "обработчик не поддерживается (отключённые источники), пропущен",
        cat_new: "новых — каналы источника, добавленные в каталог",
        cat_disabled: "выключено — каналы, пропавшие из источника (alive = 0); привязки сохраняются",
        cat_reenabled: "вернулось — ранее выключенные каналы, снова появившиеся в источнике",
        cat_unchanged: "без изменений — каналы, которые есть и в источнике, и в каталоге"
      },
      Импорт_EPG_сервис_ошибка: "ошибка",
      Импорт_EPG_сервис_не_отвечает: "Сервис импорта не отвечает",
      Импорт_EPG_сервис_продолжается: "Импорт продолжается",
      Импорт_EPG_сервис_проверить_снова: "Проверить снова",
      Импорт_EPG_сервис_состояние_недоступно: "Состояние недоступно, проверьте программу канала",
      К_списку_абонентов: "К списку абонентов",
      К_списку_пакетов: "К списку пакетов",
      К_списку_каналов: "К списку каналов",
      К_списку_сервисов: "К списку сервисов",
      К_списку_категорий: "К списку категорий",
      К_списку_колокейшинов: "К списку колокейшинов",
      К_списку_фильмов: "К списку фильмов",
      "Каналы_-_Редактирование": "Каналы - Редактирование",
      Каналы_источников: "Каналы источников",
      Каналы: "Каналы",
      "Категории_-_Редактирование": "Категории - Редактирование",
      Категории: "Категории",
      "Категории_-_Extended": "Extended",
      Колокейшн: "Колокейшн",
      Колокейшены: "Колокейшены",
      "Колокейшены_-_Редактирование": "Колокейшены - Редактирование",
      Колокейшн_запасной: "Colocation spare",
      Колокейшин_запасной_включен: "Colocation spare enabled",
      Комментарий: "Комментарий",
      Контакты: "Контакты",
      Коррекция_времени_EPG: "Коррекция времени EPG (сек.)",
      "Лайв-стриминг": "Лайв-стриминг",
      Логотип: "Логотип",
      Макс_адресов: "Макс. адресов",
      Макс_потоков: "Макс. потоков",
      Минимальный_возраст: "Мин.возраст",
      Название: "Название",
      Неверное_значение: "Неверное значение",
      Нет: "Нет",
      Новый_пароль: "Новый пароль",
      Обработчик: "Обработчик",
      Общие: "Общие",
      Описание: "Описание",
      Опции: "Опции",
      Отмена: "Отмена",
      Ошибка_получения_данных: "Ошибка получения данных",
      Ошибка_сохранения: "Ошибка сохранения",
      Ошибка_удаления_записи: "Ошибка удаления записи",
      "Пакеты_-_Редактирование": "Пакеты - Редактирование",
      Пакеты: "Пакеты",
      Пароли_не_совпадают: "Пароли не совпадают",
      Пароль_не_может_быть_пустым: "Пароль не может быть пустым",
      Пароль_успешно_изменен: "Пароль успешно изменен",
      Пароль: "Пароль",
      Партнёр: "Партнёр",
      потоки_клонирование_завершилось: "Клонирование выполнено",
      потоки_ошибка_клонирования: "Клонирование не выполнено",
      потоки_клонирование: "Клонирование",
      "потоки_действительно_клонировать?": "Действительно клонировать?",
      Потоки: "Потоки",
      Посмотреть_потоки: "Streams",
      "Поток_-_Редактирование": "Stream - Edit",
      Тип_аккаунта: "Тип",
      Тип_аккаунта_дата_обновления: "Тип обновлён",
      Повторите_пароль: "Повторите пароль",
      "Пользователи_-_Редактирование": "Пользователи - Редактирование",
      Пользователи: "Пользователи",
      Порядок_сохранён: "Порядок сохранён",
      Посмотреть_потоки: "Посмотреть потоки",
      Применять_точные_метки: "Применять точные метки",
      "Программа_передач_-_Просмотр": "Программа передач - Просмотр",
      "Продолжительность_хранения_записи_(дней)":
        "Продолжительность хранения записи (дней)",
      Редактирование_абонента: "Редактирование абонента",
      Родительский_код: "Родительский код",
      "Роли_-_Редактирование": "Роли - Редактирование",
      Роли: "Роли",
      "Сервисы_-_Редактирование": "Сервисы - Редактирование",
      "Сервисы_ключей_-_Редактирование": "Сервисы ключей - Редактирование",
      Сервисы_ключей: "Сервисы ключей",
      Сервисы: "Сервисы",
      Сменить_пароль: "Сменить пароль",
      Смещение_прямого_эфира: "Смещение прямого эфира",
      Гео_контроль: "Гео контроль",
      Смотреть_программу: "Смотреть программу",
      Создать: "Создать",
      Сохранить: "Сохранить",
      "Список_каналов_-_Просмотр": "Список каналов - Просмотр",
      Управление_Источниками_импорта: "Управление Источниками импорта",
      Статистика: "Статистика",
      Статистика_Dashboard: "Дашбоард",
      Статистика_Дневной_отчет: "Отчеты",
      Статистика_Megogo: "Megogo",
      Статистика_Создание_Отчета: "Создание отчета",
      Статистика_Отчет_Готов: "Отчет готов",
      Статистика_Лог_запросов: "Лог запросов",
      Статистика_Лог_сессий: "Лог сессий",
      Токен: "Shortcode",
      Timeshift_Enabled: "Timeshift",
      Apks: "Apks",
      Apk_Добавить: "Добавить Apk",
      Apk_Редактирование: "Apk Редактирование",
      Apk_enabled: "Включен",
      Apk_description: "Описание",
      Apk_version: "Версия",
      Apk_build: "Сборка",
      Apk_payload: "APK",
      Apk_name: "Имя файла",
      Apk_ips_only: "IPs: CIDR разрешения",
      Apk_ips_exclude: "IPs: CIDR исключения",
      Apk_ips_list: "IPs список разрешенных",
      Apk_ips_re_only: "IPs крайние цифры: разрешения",
      Apk_ips_re_exclude: "IPs крайние цифры: исключения",
      Apk_brand: "Брэнд",
      Видеотека: "Видеотека",
      Видеотека_Каталог: "Видеотека",
      "Видеотека_-_Редактирование": "Видеотека - Редактирование",
      "Видеотека_-_Описание": "Описание",
      "Видеотека_-_Жанры": "VOD Жанры",
      "Видеотека_-_id": "ID",
      "Видеотека_-_Продолжительность": "Mins",
      "Видеотека_-_Контроль": "Контроль",
      "Видеотека_-_Режисеры": "Режисеры",
      "Видеотека_-_Актеры": "Актеры",
      "Видеотека_-_Год": "Год",
      "Видеотека_-_Пакеты": "VOD Пакеты",
      "Видеотека_-_Пакеты_Редактирование": "VOD Пакеты - Редактирование",
      "Видеотека_-_Пакеты_Список_фильмов": "VOD Пакеты - Список_фильмов",
      "Видеотека_-_Сервисы": "VOD Сервисы",
      Страны: "Страны",
      Нет_прав_доступа_на_чтение: "No permissions to read",
      Нет_прав_доступа_на_обновление: "No permissions to update"
    }
  }
};



// WEBPACK FOOTER //
// ./src/localization/message.js